'use client'

import { useProductData } from '@/components/ProductData/ProductDataProvider'
import { useSyncPriceIntentAttributionFromUrl } from '@/features/recommendations/usePriceIntentAttribution'

export function PriceIntentAttributionCapture() {
  const productData = useProductData()
  useSyncPriceIntentAttributionFromUrl(productData.name)
  return null
}
